import { DadosRespostaFazerChamadaType } from '../types';

export function mapperDadosRespostaFazerChamada(data: string): DadosRespostaFazerChamadaType {
  const dadosObj = data
    .trim()
    .split(';')
    .reduce(
      (a, c, i) => ({
        ...a,
        [['chaveRetorno', '', 'servidor', 'idChamada', 'idRetorno', 'descRetorno', 'contrato', 'callid', 'operadora'][
          i
        ]]: c,
      }),
      {}
    );

  return dadosObj as DadosRespostaFazerChamadaType;
}
